export const hasVirtualAssistant = (courseSlug: string, brandSlug: string, videoId: string): boolean => {
    const videosIdsWhereShouldNotDisplayVirtualAssistant = [
        "214031",
        "213901",
        "213910",
        "213905",
        "213917",
        "213918",
        "213902",
        "213920",
        "213914",
        "213916",
        "213904",
        "213903",
        "214028"
    ];

    const proenemCoursesWithVirtualAssistant =
        [
            "turma-abril-26-med",
            "pe-2026-turma-de-abril",
            "turma-extensiva-med-26",
            "med-vip-2025",
            "extensiva-med-25",
            "med-turma-de-marco-25",
            "med-abril-25",
            "med-turma-de-marco-25",
            "med-abril-25",
            "enempro-2026-ia",
            "extensiva-med-26",
            "extensiva-26",
            "semi-extensiva-med-25",
            "turma-de-junho-med-25",
            "turma-intensiva-25",
            "turma-intensiva-25.set",
            "pmed-turma-intensiva-25.set",
            "pmed-turma-intensiva-26"
        ].includes(courseSlug) && brandSlug === "proenem";
    const promedicinaCoursesWithVirtualAssistant =
        [
            "turma-abril-26-med",
            "pe-2026-turma-de-abril",
            "turma-extensiva-med-26",
            "med-vip-2025",
            "extensiva-med-25",
            "med-turma-de-marco-25",
            "med-abril-25",
            "med-turma-de-marco-25",
            "med-abril-25",
            "enempro-2026-ia",
            "extensiva-med-26",
            "extensiva-26",
            "semi-extensiva-med-25",
            "turma-de-junho-med-25",
            "turma-intensiva-25",
            "turma-intensiva-25.set",
            "pmed-turma-intensiva-25.set",
            "pmed-turma-intensiva-26"
        ].includes(courseSlug) && brandSlug === "promedicina";

    return (
        !videosIdsWhereShouldNotDisplayVirtualAssistant.includes(videoId) &&
        (!!proenemCoursesWithVirtualAssistant || !!promedicinaCoursesWithVirtualAssistant)
    );
};
